import { z } from 'zod';
import { paginationQuery } from './common.js';
// ── in-app (minimal, siehe docs/notifications.md) ───────────────────────────
export const notificationQuery = paginationQuery.extend({
    unreadOnly: z.enum(['true', 'false']).optional(),
});
// ── Web Push ─────────────────────────────────────────────────────────────────
// Form eines `PushSubscriptionJSON` (Browser Push API) — siehe
// docs/notifications.md für den vollen Ablauf (Abo anlegen, VAPID, Versand).
export const webPushSubscribeRequest = z.object({
    endpoint: z.string().url(),
    keys: z.object({
        p256dh: z.string().min(1),
        auth: z.string().min(1),
    }),
});
export const webPushUnsubscribeRequest = z.object({
    endpoint: z.string().url(),
});
//# sourceMappingURL=notifications.js.map